import { useNavigate } from "react-router-dom";

import styled from "styled-components";
import { StyledButton } from "@components";
import { PATH_SEARCH_RESULT } from "@routes";
import { selectSearchCategories, useAppSelector } from "@redux";

interface IProps {
    onClickFilter: () => void;
}

export const SearchMobileComponent = (props: IProps) => {
    const { onClickFilter } = props;
    const navigate = useNavigate();
    const searchCategories = useAppSelector(selectSearchCategories);

    const hasAnyFilterSelected = () => {
        const hasName = !!searchCategories.name?.trim();
        const hasAccommodation = (searchCategories.accommodation?.length ?? 0) > 0;
        const hasActivities = (searchCategories.activities?.length ?? 0) > 0;
        const hasSuppliers = (searchCategories.suppliers?.length ?? 0) > 0;
        const hasTransports = (searchCategories.transports?.length ?? 0) > 0;
        const hasDuration = !!searchCategories.duration;
        const hasCountry = !!searchCategories.countries?.id;
        const hasState = !!searchCategories.states?.id;
        const hasRegion = !!searchCategories.regions?.id;
        const hasLocality = !!searchCategories.localities?.id;

        return hasName || hasAccommodation || hasActivities || hasSuppliers || 
               hasTransports || hasDuration || hasCountry || hasState || hasRegion || hasLocality;
    };

    const canSearch = hasAnyFilterSelected();

    const handleSearch = () => {
        if (canSearch) {
            navigate(PATH_SEARCH_RESULT);
        }
    };

    return (
        <Container>
            <div className="searchBox">
                <div className="input">
                    <div 
                        className="icon" 
                        onClick={handleSearch}
                        style={{ cursor: canSearch ? 'pointer' : 'not-allowed', opacity: canSearch ? 1 : 0.5 }}
                    >
                        <img src="/images/fi_search.png" alt="" />
                    </div>
                    <input type="text" className="searchInput" placeholder="Search by keyword" />
                </div>
                <button className="filterBtn" onClick={onClickFilter}>
                    <img src="/images/fi_sliders.png" alt="" />
                    <span>Filter</span>
                </button>
            </div>
            <div className="searchBtn">
                <SearchButton 
                    onClick={handleSearch}
                    disabled={!canSearch}
                    style={{ opacity: canSearch ? 1 : 0.5, cursor: canSearch ? 'pointer' : 'not-allowed' }}
                >
                    Search
                </SearchButton>
            </div>
        </Container>
    );
};

const Container = styled.div`
    background-color: #fff;

    .searchBox {
        display: flex;
        border-bottom: 1px solid ${(props) => props.theme.colors.gray_5};

        .input {
            flex: 10;
            padding: 16px;
            display: flex;
            border-right: 1px solid ${(props) => props.theme.colors.gray_5};

            .icon {
                width: 54px;
                height: 54px;
                background-color: ${(props) => props.theme.colors.gray_6};
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .searchInput {
                background-color: ${(props) => props.theme.colors.gray_6};
                flex: 1;

                &::placeholder {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 22px;
                    color: ${(props) => props.theme.colors.gray_3};
                }
            }
        }

        .filterBtn {
            flex: 3;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            span {
                font-size: 16px;
                font-weight: 700;
                line-height: 26px;
                color: ${(props) => props.theme.colors.black};
            }
        }
    }

    .searchBtn {
        padding: 24px 16px;
    }
`;

const SearchButton = styled(StyledButton)`
    margin-top: 0;
`;
